import React from 'react'
import {
  Grid,
  Typography,
  Card,
  CardContent,
  useMediaQuery,
  Button,
} from '@mui/material'
import { Formik, Form, Field } from 'formik'
import { TextField } from 'formik-material-ui'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import axios from 'axios'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import { useTheme } from '@mui/material'
import { ValuesSubmitContactUs } from '../../../types'
import styled from '@emotion/styled'
import { useConfirm } from 'material-ui-confirm'

const StyledButton = styled(Button)({
  color: 'white'
})

interface MyFormValues {
  name: string;
  email: string;
  phonenumber: string;
  message: string;
}

const ContactUs = () => {
  const theme = useTheme()

const confirm = useConfirm()

  const matchesSM = useMediaQuery(theme.breakpoints.up('sm'))
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))

  const initialValues: MyFormValues = { name: '', email: '', phonenumber: '', message: '' }

  const validationSchema = yup.object({
    name: yup.string().required('Required'),
    email: yup.string().required('Required'),
    message: yup.string().required('Required'),
  })

  const onSubmit = async (values: ValuesSubmitContactUs, { setSubmitting }: any) => {
    confirm({
      description: 'Bạn có chắc không? / Are you sure?',
      title: 'Xác nhận gửi tin nhắn / Confirm to send',
    }).then(() => {
      setTimeout(() => {
        try {
          const config = {
            headers: {
              'Content-Type': 'application/json',
            },
          }
  
          axios
            .post('/api/contact-us', values, config)
            .then((res) => toast.success(res.data.msg))
            .catch((err) => {
              toast.error('Send email failed')
            })
        } catch (error) {
          console.error(error)
        }
        setSubmitting(false)
      }, 400)
    }).catch(() => { })
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ isSubmitting, isValid, dirty }) => (
        <Form>
          <Grid
            container
            direction="column"
            justifyContent="center"
            style={{
              margin: matchesMD ? "0 0 2em" : matchesSM ? "0 0 2em" : "0 0 2em",
            }}
            className="container"
          >
            <Grid item style={{ alignSelf: "center", marginBottom: "1em" }}>
              <Typography
                variant={matchesSM ? "h4" : "h5"}
                style={{ textTransform: "uppercase", fontWeight: 500 }}
              >
                Liên hệ với chúng tôi
                <br />
                Contact us
              </Typography>
            </Grid>

            <Grid item style={{ alignSelf: "center", marginBottom: "2em" }}>
              <Card
                style={{
                  backgroundColor: "#F5D832",
                  padding: matchesMD ? "1em" : undefined,
                }}
              >
                <CardContent>
                  <Grid container direction="column">
                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <EmailIcon />
                      </Grid>
                      <Grid item>
                        <Typography variant="body1">
                          &nbsp;<strong>Email: </strong>
                          youspeak.service@gmail.com
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <PhoneIcon />
                      </Grid>
                      <Grid item>
                        <Typography variant="body1">
                          &nbsp;<strong>Hotline: </strong>0788 723 027
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card>
                <CardContent>
                  <Grid container direction="column" spacing={1}>
                    <Grid item>
                      <Typography variant="body1">
                        Nếu bạn có bất cứ câu hỏi nào, vui lòng để lại lời nhắn
                        cho chúng tôi.
                        <br />
                        If you have any questions, please send us a message.
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      container
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      style={{ width: "100%" }}
                      spacing={2}
                    >
                      <Grid
                        item
                        style={{
                          width: matchesMD ? "70%" : matchesSM ? "80%" : "100%",
                        }}
                      >
                        <Field
                          name="name"
                          type="text"
                          component={TextField}
                          label="Tên / Name"
                          style={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid
                        item
                        style={{
                          width: matchesMD ? "70%" : matchesSM ? "80%" : "100%",
                        }}
                      >
                        <Field
                          name="email"
                          type="email"
                          component={TextField}
                          label="Email của bạn / Your email"
                          style={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid
                        item
                        style={{
                          width: matchesMD ? "70%" : matchesSM ? "80%" : "100%",
                        }}
                      >
                        <Field
                          name="phonenumber"
                          type="number"
                          component={TextField}
                          label="Số điện thoại / Your phone number"
                          style={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid
                        item
                        style={{
                          width: matchesMD ? "70%" : matchesSM ? "80%" : "100%",
                        }}
                      >
                        <Field
                          name="message"
                          type="text"
                          component={TextField}
                          label="Tin nhắn / Message"
                          multiline
                          rows={6}
                          style={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid
                        item
                        style={{
                          width: matchesMD ? "70%" : matchesSM ? "80%" : "100%",
                        }}
                      >
                        <StyledButton
                          variant="contained"
                          color="primary"
                          type="submit"
                          disabled={
                            isSubmitting || !isValid || !(isValid && dirty)
                          }
                          style={{ width: "100%" }}
                        >
                          Gửi / Send message
                        </StyledButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default ContactUs
